<template>
  <div class="content">
    <video
      src="../assets/loginImg/denglu02.mp4"
      loop="loop"
      autoplay="autoplay"
      muted
    ></video>

    <div class="title">
      <img src="../assets/loginImg/title.png" alt="" />
      <!-- <img src="../assets/images/fish-resource-bg.png" alt="" /> -->
    </div>

    <div v-if="false">
      <!-- <div>
        <img class="img" src="../assets/loginImg/形状8.png" />
      </div> -->
      <div class="login-box">
        <!-- <div>
          <img src="../assets/loginImg/yh.png" alt="" />&nbsp;&nbsp; 用 户 登 录
        </div> -->
        <div>
          <label class="input-box">
            <div class="input-box-content">
              <img src="../assets/loginImg/peo.png" style="" />
            </div>
            <div>
              <input
                type="text"
                placeholder="用户名"
                :class="'log-input' + (account == '' ? 'login-input-empty' : '')"
                v-model="account"
              />
            </div>
          </label>
          <label class="input-box">
            <div class="input-box-content">
              <img src="../assets/loginImg/s.png" style="" />
            </div>
            <div>
              <input
                type="password"
                placeholder="密码"
                :class="'log-input' + (password == '' ? 'login-input-empty' : '')"
                v-model="password"
              />
            </div>
          </label>

          <div>
            <div style="margin-left: 18%; float: left">
              <input
                type="text"
                placeholder="验证码"
                :class="'log-input' + (code == '' ? 'login-input-empty' : '')"
                v-model="code"
                class="code-input"
              />
            </div>
            <div class="code">
              <Sidentify @showCode="showCode"></Sidentify>
            </div>
          </div>
          <div class="login-btn" @click="login">
            <p style="">登 录</p>
            <img src="../assets/loginImg/dl.png" style="" />
          </div>
        </div>
      </div>
    </div>

    <!-- New Login -->
    <div class="login--box" v-if="false">
      <div :class="focus === 1 ? 'form--focus' : 'form--control'">
        <div>
          <img src="../assets/loginImg/user1.png" style="" />
        </div>
        <div class="divider"></div>
        <input
          type="text"
          placeholder="用户名"
          v-model="account"
          @focus="inputFocus(1)"
        />
      </div>
      <div :class="focus === 2 ? 'form--focus' : 'form--control'">
        <div>
          <img src="../assets/loginImg/lock1.png" style="" />
        </div>
        <div class="divider"></div>
        <input
          type="password"
          placeholder="密码"
          v-model="password"
          @focus="inputFocus(2)"
        />
      </div>
      <div class="remenberPassword">
        <el-checkbox v-model="rememberPassword">记住密码</el-checkbox>
      </div>
      <div :class="focus === 3 ? 'form--focus' : 'form--control'" v-if="false">
        <input type="text" placeholder="验证码" v-model="code" @focus="inputFocus(3)" />
        <Sidentify @showCode="showCode" style="width: 108px"></Sidentify>
      </div>
      <div class="login--btn" @click="login">登录</div>
    </div>

    <!-- 账户与微信扫码登录 -->
    <div class="user-wx-login">
      <!-- 账号与扫码切换 -->
      <div class="login-container">
        <div class="login-tabs">
          <div 
            class="login-tab-item" 
            :class="{'active': !isWx}" 
            @click="isWx = false"
          >
            账户登录
          </div>
          <div 
            class="login-tab-item" 
            :class="{'active': isWx}" 
            @click="isWx = true"
          >
            微信登录
          </div>
        </div>
        
        <div class="login-content">
          <!-- 账户登录表单 -->
          <div v-if="!isWx" class="account-login">
            <div class="form-item" :class="focus === 1 ? 'form--focus' : ''">
              <div class="icon-wrapper">
                <img src="../assets/loginImg/user1.png" />
              </div>
              <input 
                type="text" 
                v-model="account" 
                placeholder="请输入用户名"
                @focus="inputFocus(1)"
              />
            </div>
            <div class="form-item" :class="focus === 2 ? 'form--focus' : ''">
              <div class="icon-wrapper">
                <img src="../assets/loginImg/lock1.png" />
              </div>
              <input 
                type="password" 
                v-model="password" 
                placeholder="请输入密码"
                @focus="inputFocus(2)"
              />
            </div>
            <div class="remember-pwd">
              <el-checkbox v-model="rememberPassword">记住密码</el-checkbox>
            </div>
            <div class="login-button" @click="login">登录</div>
          </div>
          
          <!-- 微信登录区域 -->
          <div v-else class="wechat-login">
            <div class="qr-code-container">
              <WeixinLogin />
            </div>
          </div>
        </div>
      </div>
    </div>


    <div style="position: absolute; top: 79%; left: 0; height: 50px">
      <div>
        <!-- 暂时隐藏 -->
        <img class="footImg" src="../assets/loginImg/btm.png" />
      </div>
      <!-- <div class="bot-text" style="">
        <p>技术支持：上海地听信息科技有限公司</p>
      </div> -->
    </div>
    <IpWarning :showIpWarning.sync="showIpWarning" v-if="showIpWarning"></IpWarning> 
  </div>
</template>
<script>
import Sidentify from "./Sidentify.vue";
import CryptoJS from "crypto-js";
import { login,loginWx } from "@/service/apis";
import IpWarning from "./IpWarning.vue";
import WeixinLogin from "./wxLoginComponents/WeixinLogin.vue";
export default {
  data() {
    return {
      account: "",
      password: "",
      code: "",
      checked: "",
      sidentify: [],
      focus: true,
      showIpWarning:false,
      rememberPassword: false,
      isWx: false
    };
  },

  components: {
    Sidentify,
    IpWarning,
    WeixinLogin
  },
  mounted(){
    let isRemberObj = JSON.parse(localStorage.getItem('remenberObj') || null)
    if(isRemberObj && isRemberObj.isRember) {
      this.rememberPassword = isRemberObj.isRember
      this.account = isRemberObj.account
      this.password = isRemberObj.password
    }
    window.addEventListener('storage', this.handleStorageChange)
  },
  beforeDestroy(){
    window.removeEventListener('storage', this.handleStorageChange)
  },
  methods: {
    handleStorageChange(event){
      if(event.key === 'wx_code'){
        if(event.newValue){
          loginWx({code: event.newValue}).then(res => {
            if (res.code == 200) {
              // 登录成功
              let { data: user } = res;
              this.$store.commit("setUser", user);
              this.$store.commit("setUserRights", user.permission);
              this.$store.commit("setUserRole", user.role);
              this.$setCookie({ yzzy_web_session: JSON.stringify(user.userInfo) }, 3 * 60 * 60);
              localStorage.setItem("user", JSON.stringify(user));
              localStorage.setItem("token", user.token);
              localStorage.setItem("isWxLogin", true);
              this.changeRemember()
              let pagePermission = this.getPagePermission();
              if(pagePermission) {
                this.$router.push({ name: pagePermission });
              } else {
                this.$message.error("您没有权限访问页面！");
              }
              this.$loading.show();
            } else if(res.code === 100 && res.data && res.data.ipDomestic ===  false) {
              this.showIpWarning = true
              this.$message.warning("登录失败：" + res.message);
            } else {
              this.$message.warning("登录失败：" + res.message);
            }
          }).catch(err => {
            this.$message.warning("登录失败");
            console.error("登录失败", err);
          })
        }
      }
      console.log('handleStorageChange',event)
    },
    login() {
      let password = this.encryptPwd(this.password);
      let account = this.account;
      if (password && account) {
        login({ username: account, pwd: password, ipLocationJudge: false, domesticJudge: true })
          .then((res) => {
            if (res.code == 200) {
              // 登录成功
              let { data: user } = res;
              this.$store.commit("setUser", user);
              this.$store.commit("setUserRights", user.permission);
              this.$store.commit("setUserRole", user.role);
              this.$setCookie({ yzzy_web_session: JSON.stringify(user.userInfo) }, 3 * 60 * 60);
              localStorage.setItem("user", JSON.stringify(user));
              localStorage.setItem("token", user.token);
              localStorage.setItem("isWxLogin", false);
              this.changeRemember()

              // this.$message.success("登录成功")
              // this.$router.push("/Home");
              let pagePermission = this.getPagePermission();
              if(pagePermission) {
                this.$router.push({ name: pagePermission });
              } else {
                this.$message.error("您没有权限访问页面！");
              }
              this.$loading.show();
            } else if(res.code === 100 && res.data && res.data.ipDomestic ===  false) {
              this.showIpWarning = true
              this.$message.warning("登录失败：" + res.message);
            } else {
              this.$message.warning("登录失败：" + res.message);
            }
          })
          .catch((err) => {
            this.$message.warning("登录失败");
            console.error("登录失败", err);
          });
      } else {
        this.$message.error("请输入正确的账号密码！");
      }
      // this.$router.push("/Home");
      // let pagePermission = this.getPagePermission();
      // if(pagePermission) {
      //   this.$router.push({ name: pagePermission });
      // } else {
      //   this.$message.error("您没有权限访问页面！");
      //   return;
      // }
    },
    // 根据页面权限判断跳转哪个页面
    getPagePermission() {
      let permission = this.$store.state.userRights;
      let routeMap = {
        home_new: "Index", // 首页
        global_fish_new: "fishAreaProductsFAO", // 全球渔业
        area_orgnization_new: "fishAreaProductsRFMO", // 区域组织页面权限
        fish_species_resources_new: "FishResource", // 鱼种资源页面权限
        ship_work_new: "ShipWorkLive", // 渔船作业页面权限
        ocean_env_new: "FishPrediction", // 海洋环境页面权限
        project_new: "fishProject", // 专题研究
      }
      for (let key in routeMap) {
        if (permission.get(key)) {
          return routeMap[key];
        }
      }
      return "";
    },

    encryptPwd(password) {
      password = CryptoJS.enc.Utf8.parse(password);
      let key = "B8701BDFB9AC8BF4273C8DD3BA0EB7F1";
      key = CryptoJS.enc.Utf8.parse(key);
      let encrypted = CryptoJS.AES.encrypt(password, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      });
      return encrypted.toString();
    },
    showCode(showCode) {
      this.sidentify = showCode;
    },
    inputFocus(value) {
      this.focus = value;
    },
    changeRemember() {
      localStorage.setItem('remenberObj', 
      JSON.stringify({ 
        isRember: this.rememberPassword,
        account: this.rememberPassword ? this.account : '',
        password: this.rememberPassword ? this.password : ''
      }))
    }
  },
};
</script>
<style lang="scss" scoped>
$inputShadow: 0px 0px 16px 4px rgb(38, 134, 243);
.content {
  width: 100%;
  height: 100%;
}
video {
  position: fixed;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
  width: 100%;
  // height: 100%;
  z-index: -100;
  -webkit-filter: grayscale(20%);
}
.title {
  padding-top: 60px;
}
.img {
  width: 30%;
  position: fixed;
  right: 35%;
  // margin-top: 60px;
  z-index: -10;
}
.login-box {
  width: 70%;
  // height: 505px;
  // padding-top: 100px;
  // padding-right: 2%;
  position: fixed;
  right: 33%;
  font-size: 20px;
  font-weight: 800;
  text-align: center;
  border: 1px solid #fe0000;
  & > div {
    border: 1px solid #fe0000;
    overflow: hidden;
  }
}
input {
  width: 100%;
  height: calc(100% - 4px);
  // border: 1px solid rgb(238, 238, 238);
  border: 1px solid #fff;
  background-color: #fff;
  // margin-top: 30px;
  padding-left: 10px;
  float: left;
  font-size: 17px;
}
input:focus {
  outline: none;
}
.input-box-content {
  width: 50px;
  height: 50px;
  // margin-top: 30px;
  margin-left: 18%;
  background: rgb(16, 65, 143);
  box-shadow: 0px 0 5px 2px rgb(136, 166, 216);
  float: left;
  display: flex;
  img {
    margin: 12px;
    padding: 1px;
  }
}
.input-box:focus {
  width: 364px;
  height: 50px;
  margin-left: 103.672px;
  box-shadow: 5px #888888;
}
.login-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 358px;
  height: 50px;
  float: left;
  margin-top: 20px;
  margin-left: 18%;
  color: white;
  cursor: pointer;
  background: linear-gradient(to right, rgb(23, 93, 189), rgb(145, 124, 163));
  p {
    // margin-top: 13px;
    // margin-left: 38%;
    // float: left;
    margin-right: 20px;
    font-weight: 100;
  }
  img {
    // float: left;
    // margin-top: 13px;
    // margin-left: 10px;
  }
}
.bot-text {
  position: fixed;
  bottom: 0;
  text-align: center;
  color: white;
  margin-left: 42%;
}
.log-input-empty {
  border: 1px solid #f37474 !important;
}
.footImg {
  width: 100%;
  margin-right: 50%;
  position: fixed;
  bottom: 0;
  z-index: -10;
}
.code {
  width: 100px;
  height: 50px;
  float: left;
  margin-top: 30px;
  margin-left: 10px;
}
.code-input {
  width: 220px;
}

.login--box {
  border: 1px solid rgba(255, 255, 255, 0.26);
  background: rgba(255, 255, 255, 0.26);
  width: 40%;
  height: 130px;
  display: flex;
  margin: 0 auto;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 120px;

  // bottom: 20%;
  .form--control {
    overflow: hidden;
    display: flex;
    height: 52px;
    width: 275px;
    // border: 1px solid #fe0000;
    position: relative;
    align-items: center;
    background: #fff;
    line-height: 52px;
    transition: box-shadow ease 0.2s;
    & > div:first-child {
      width: 50px;
      text-align: center;
    }
    .divider {
      height: 55%;
      border-left: 1px solid #dcdfe6;
    }
    img {
      width: 25px;
      height: 25px;
      vertical-align: middle;
    }
    input {
      flex: 1;
    }
  }
  .form--focus {
    overflow: hidden;
    display: flex;
    height: 52px;
    width: 275px;
    box-sizing: border-box;
    transition: box-shadow ease 0.2s;
    // border: 2px solid #000;
    // box-shadow:0px 0px 4px blue;
    box-shadow: $inputShadow;
    position: relative;
    align-items: center;
    background: #fff;
    line-height: 52px;
    & > div:first-child {
      width: 50px;
      text-align: center;
    }
    .divider {
      height: 55%;
      // border-left: 1px solid #dcdfe6;
    }
    img {
      width: 25px;
      height: 25px;
      vertical-align: middle;
    }
    input {
      flex: 1;
    }
  }

  .form--control:hover {
    // border: 2px solid #000;
    box-shadow: $inputShadow;
  }

  .login--btn {
    width: 127px;
    height: 52px;
    line-height: 52px;
    background: #2686f3;
    font-size: 22px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    letter-spacing: 2px;
    font-size: 20px;
    cursor: pointer;
    transition: all ease 0.2s;
  }
  .login--btn:hover,
  .login--btn:focus {
    background: #7eafe6;
  }
}
.remenberPassword {
  position: absolute;
  right: 180px;
  bottom: 10px;
  .el-checkbox {
    color: #fff !important;
  }
}

.user-wx-login {
  position: fixed;
  left: 50%;
  bottom: -80px;
  transform: translate(-50%, -50%);
  width: 460px;
  
  .login-container {
    background: rgba(61,76,95,0.7);
    border-radius: 8px;
    overflow: hidden;
    border: 2px solid #7a838f;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  }

  .login-tabs {
    display: flex;
    border-bottom: 2px solid #7a838f;
    
    .login-tab-item {
      flex: 1;
      height: 46px;
      line-height: 46px;
      text-align: center;
      cursor: pointer;
      font-size: 16px;
      color: #b2b8c0;
      transition: all 0.3s;
      
      &.active {
        color: #fff;
        font-weight: bold;
        position: relative;
        // background: #2686f3;
        
        // &:after {
        //   content: '';
        //   position: absolute;
        //   bottom: 0;
        //   left: 0;
        //   width: 100%;
        //   height: 2px;
        //   background: #2686f3;
        // }
      }
      
      &:hover {
        // color: #2686f3;
      }
    }
  }

  .login-content {
    padding: 20px;
    height: 300px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    .account-login {
      width: 100%;
      .form-item {
        display: flex;
        align-items: center;
        // border: 1px solid #dcdfe6;
        background-color: rgba(255, 255, 255, 1);
        border-radius: 4px;
        margin-bottom: 20px;
        transition: all 0.3s;
        &:hover {
          box-shadow: $inputShadow;
          border-color: #2686f3;
        }
        .icon-wrapper {
          width: 50px;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px solid #dcdfe6;
          img {
            width: 20px;
            height: 20px;
          }
        }
        input {
          flex: 1;
          height: 50px;
          padding: 0 15px;
          border: none;
          background: none;
          font-size: 14px;
          &:focus {
            outline: none;
          }
        }
      }
      .form--focus {
        box-shadow: $inputShadow;
        border-color: #2686f3;
      }
  
      .remember-pwd {
        margin-bottom: 20px;
        text-align: end;
        .el-checkbox {
          color: #fff;
        }
      }
  
      .login-button {
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: #2686f3;
        color: white;
        border-radius: 4px;
        cursor: pointer;
        font-size: 16px;
        transition: all 0.3s;
        
        &:hover {
          background: #1c6dd6;
        }
      }
    }
    .form--focus {
      background-color: rgba(255, 255, 255, 0.8);
    }
  }

  .wechat-login {
    text-align: center;

  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue